import { render, staticRenderFns } from "./GoodBaseInfo.vue?vue&type=template&id=a76fbca4&scoped=true&"
import script from "./GoodBaseInfo.vue?vue&type=script&lang=js&"
export * from "./GoodBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodBaseInfo.vue?vue&type=style&index=0&id=a76fbca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76fbca4",
  null
  
)

export default component.exports